/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React base styles
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";

// Material Dashboard 2 PRO React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { borderWidth } = borders;

const tableCell = {
  styleOverrides: {
    root: {
      padding: `${pxToRem(6)} ${pxToRem(12)}`,
      borderBottom: `${borderWidth[1]} solid rgba(0, 0, 0, 0.08)`,
    },
    head: {
      padding: `${pxToRem(8)} ${pxToRem(12)}`,
    },
  },
};

export default tableCell;
